<template >
  <div class="ma-5">  
    <v-row class="mb-1">
      <v-col cols="12" md="3">
        <h2 class="text-left">Admissions</h2>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2">
        <div v-if="currentUser.privileges.canCreateAdmissions && tab==0">
          <v-btn 
            color="white" 
            @click="showDialog = true"
            rounded
            block
            light
          >
            Import
            <v-icon right>
              mdi-import
            </v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="3"  v-if="currentUser.privileges.canManageEnquirySources">
        <div> <!-- permissions -->
          <v-btn
            color="primary"
            rounded
            block
            id="enquiry-sources-btn"
            :to="{name:'ManageEnquiries'}"
          > 
            Enquiry Sources
          </v-btn>
        </div>
      </v-col>
      
      <v-col cols="12" md="3">
        <div v-if="currentUser.privileges.canCreateAdmissions">
          <v-btn rounded block color="primary" id="lead-enquiry-btn" :to="{ name: 'AddAdmission' }">
            New Lead / Enquiry
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-tabs v-model="tab" class="ma-0 pa-0">
      <v-tabs-slider :color="tab == 5 ? 'red' : 'primary'"></v-tabs-slider>

      <v-tab v-for="item in items.filter(item => currentUser.privileges[item.requiredPermission])" :key="item.step" class="">
        
          <span :class="item.class">{{ item.tab }}  </span>
          <v-badge class="ml-2" :color="item.color" :content="getCount(item)" v-if="admission_counts && getCount(item) > 0">
          

          </v-badge>
      </v-tab>
      <v-tab-item v-for="item in items.filter(item => currentUser.privileges[item.requiredPermission])" :key="item.step" class="tabContent">
        <v-card flat>
          <v-container fluid>
            <component :is="item.content" @refreshCounts="getAdmissionCounts" />
          </v-container>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <ImportExcelDialog
			:showDialog="showDialog"
			title="Import Enquiry Details"
			@closeImportDialog="closeImportDialog"
			:endpoint="endpoints.importEnquiryDetails"
			:staticFile="endpoints.static.enquiryImportFile"
		/>

    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import ImportExcelDialog from "@components/widgets/dialogs/ImportExcelDialog.vue";
import TourHelper from "@utils/tour_helper";

export default {
  name: "Admissions",

  components: {
    EnquiryList: () => import("@components/admission/EnquiryList"),
    ApplicationsList: () => import("@components/admission/ApplicationsList"),
    UploadDocumentsList: () => import("@components/admission/UploadDocumentsList"),
    EvaluationsList: () => import("@components/admission/EvaluationsList"),
    ConfirmationsList: () => import("@components/admission/ConfirmationsList"),
    TerminationsList: ()=> import("@components/admission/TerminationsList"),
    ImportExcelDialog
  },

  data() {
    return {
      tab: 0,
      color: "#f6f6f6",			
      showDialog: false,
			endpoints: endpoints,
      items: [
        {
          step: 1,
          tab: "Leads / Enquiry",
          content: "EnquiryList",
          requiredPermission: 'canViewOwnEnquiries',
          color: "primary",
          class: null,
        },
        {
          step: 2,
          tab: "Application",
          content: "ApplicationsList",
          requiredPermission: 'canViewApplications',
          color: "primary",
          class: null,
        },
        {
          step: 3,
          tab: "Upload Documents",
          content: "UploadDocumentsList",
          requiredPermission: 'canViewUploadedDocuments',
          color: "primary",
          class: null,
        },
        {
          step: 4,
          tab: "Evaluation",
          content: "EvaluationsList",
          requiredPermission: 'canEvaluateAdmissions',
          color: "primary",
          class: null,
        },
        {
          step: 5,
          tab: "Confirmation",
          content: "ConfirmationsList",
          requiredPermission: 'canViewConfirmations',
          color: "primary",
          class: null,
        },
        {
          step: 6,
          tab: "Terminations",
          content: "TerminationsList",
          requiredPermission: 'canViewTerminations',
          color: "red",
          class: "red--text",
        }
      ],
      snackbar: {
        visible: false,
        text: "",
      },
      admission_counts : [],
    };
  },

  computed:{
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },

  methods:{
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Admissions", description: "View and check progress of admissions of institute in this section.", videoLink: "https://youtube.com"});
        steps.push({id: '2', title: "Leads/Enquiry List", description: "View enquiry list of existing admission application, click on enquiry no. of an application for more information.", videoLink: "https://youtube.com"});
        steps.push({id: '3', title: "Application List", description: "View application list of existing admission applications.", videoLink: "https://youtube.com"});
        steps.push({id: '4', title: "Upload Document", description: "View all Documents that have been uploaded in applications.", videoLink: "https://youtube.com"});
        steps.push({id: '5', title: "Evaluation", description: "View all applications that are yet to be evaluated.", videoLink: "https://youtube.com"});
        steps.push({id: '6', title: "Confirmation List", description: "View confirmation list of existing admission applications.", videoLink: "https://youtube.com"});
        steps.push({id: '7', title: "Terminations List", description: "<span style='color:red;'>Terminations List</span> consists of all the rejected applications.", videoLink: "https://youtube.com"});
        steps.push({id: '8', description: "Navigate and view enquiry sources", position:'top' ,el: '#enquiry-sources-btn'});
        steps.push({id: '9  ', description: "Add new admission under this section." ,el: '#lead-enquiry-btn'});
        TourHelper.startTour(this, "admissions", steps);
    },

    async getAdmissionCounts() {
      var url = endpoints.admissions + "get/counts/";
      this.admission_counts = await api.call(this.apiEssentials, url);
    },

    getCount(item){
      var count = this.admission_counts.find(x=> x.status == item.step)
      if(count!=null){
        return count.total
      }
      return 0;
    },

    // receive dialog status from the component
		closeImportDialog(showDialog) {
			this.showDialog = showDialog
		},

    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
  },

  watch:{
    $route() {
      // react to route changes...
      if(Object.prototype.hasOwnProperty.call(this.$route.query,'step')){
        this.tab = Number(this.$route.query.step) - 1;  
      }
    }
  },

  created(){
    this.getAdmissionCounts();
    if(Object.prototype.hasOwnProperty.call(this.$route.query,'step')){
      this.tab = Number(this.$route.query.step) - 1;
    }
    this.handleTour();
  }
};
</script>

<style>
.tabContent {
  margin-top: 10;
  padding-top: 10;
}
</style>